export const INVITE_PERMISSION_LABELS = {
    canBuild: 'Can build',
    canManageBilling: 'Can manage billing',
    canManageSigning: 'Can manage signing',
    canManageSso: 'Can manage SSO',
    canManageUsers: 'Can manage users',
    canRelease: 'Can release',
    isAdmin: 'Admin',
};
export const formatInvitePermissionSummary = (permissions) => {
    if (permissions.isAdmin === true)
        return INVITE_PERMISSION_LABELS.isAdmin;
    const enabled = Object.entries(permissions)
        .filter(([, value]) => value === true)
        .map(([key]) => INVITE_PERMISSION_LABELS[key]);
    return enabled.join(', ');
};
export const FULL_OWNER_PERMISSIONS = {
    canBuild: true,
    canManageBilling: true,
    canManageSigning: true,
    canManageSso: true,
    canManageUsers: true,
    canRelease: true,
    isAdmin: true,
};
/** Admins have every permission, whatever else was saved. */
export const normalizeInvitePermissions = (permissions) => {
    const isAdmin = (permissions === null || permissions === void 0 ? void 0 : permissions.isAdmin) === true;
    return {
        canBuild: isAdmin || (permissions === null || permissions === void 0 ? void 0 : permissions.canBuild) === true,
        canManageBilling: isAdmin || (permissions === null || permissions === void 0 ? void 0 : permissions.canManageBilling) === true,
        canManageSigning: isAdmin || (permissions === null || permissions === void 0 ? void 0 : permissions.canManageSigning) === true,
        canManageSso: isAdmin || (permissions === null || permissions === void 0 ? void 0 : permissions.canManageSso) === true,
        canManageUsers: isAdmin || (permissions === null || permissions === void 0 ? void 0 : permissions.canManageUsers) === true,
        canRelease: isAdmin || (permissions === null || permissions === void 0 ? void 0 : permissions.canRelease) === true,
        isAdmin,
    };
};
